import { useState } from "react";



export default function OrderDropElement({belongsTo, informAboutDrop}) {
    const [isBeingDraggedOver, setIsBeingDraggedOver] = useState(false)


    function beingDraggedOver(event){
        event.stopPropagation();
        event.preventDefault();
        const data = event.dataTransfer.getData("text")
    }

    function dragEnter(index){
        setIsBeingDraggedOver(true)
    }

    function dragOverLeave(index){
        setIsBeingDraggedOver(false)
    }

    function drop(){
        setIsBeingDraggedOver(false)
        informAboutDrop(belongsTo)
    }

    return (
    <div className='dnoItemDragTarget' >
        <div className={'dnoItem ' + (isBeingDraggedOver ? "isBeingDraggedOver " : "")}
            onDragOver={beingDraggedOver} 
            onDragLeave={dragOverLeave} 
            onDragEnter={dragEnter}
            onDrop={drop}
            >
                {isBeingDraggedOver 
                ?
                <hr className="dashed"></hr>
                :
                <hr className="solid"></hr>
                }
            </div>
    </div>
    )
}